import { getRoles } from "../api/role"
import { getUserNotifications, getUsers, getUsersByIds, updateUser } from "../api/user"
import { User, UserAuthorizations, UserDTO, UserNotification, UserRole, UserType } from "../types/user"

export async function fetchUserPagedData(roles: UserRole[], params?: PagedRequestParams): Promise<PagedResult<User>> {
    const res = await getUsers(params)

    const roleMap: Record<string, UserRole> = {}
    roles.forEach(r => {
        roleMap[r.id] = r
    })

    const users: User[] = res.items.map(dto => dtoToUser(dto, roleMap))
    return {
        ...res,
        items: users
    }
}

export async function fetchUsersByIds(ids: string[], roles: UserRole[]): Promise<User[]> {
    const res = await getUsersByIds(ids)

    const roleMap: Record<string, UserRole> = {}
    roles.forEach(r => {
        roleMap[r.id] = r
    })

    const users: User[] = res.items.map(dto => dtoToUser(dto, roleMap))
    return users
}

export async function manageUpdateUser(user: User): Promise<ErrorMessage | User> {
    const res = await updateUser(userToDTO(user))
    if (res && 'errorCode' in res) {
        return res
    }

    return dtoToUser(res, { [user.role.id]: user.role })
}

export async function fetchUserRoles(): Promise<UserRole[]> {
    const res = await getRoles()
    return res.items
}

export async function fetchUserNotifications(userid: string): Promise<Record<string, UserNotification>> {
    return await getUserNotifications(userid)
}

function dtoToUser(dto: UserDTO, roleMap: Record<string, UserRole>): User {
    const role = roleMap[dto.roleId]

    return {
        id: dto.id,
        username: dto.username,
        firstName: dto.firstName,
        lastName: dto.lastName,
        email: dto.email,
        role: role,
        type: UserType[dto.type as keyof typeof UserType],
        permissions: dto.permissions.map(p => UserAuthorizations[p as keyof typeof UserAuthorizations]),
        enabled: dto.enabled,
        editable: dto.editable
    }
}

function userToDTO(user: User): UserDTO {
    return {
        id: user.id,
        username: user.username,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        roleId: user.role.id,
        type: UserType[user.type],
        permissions: user.permissions.map(p => UserAuthorizations[p]),
        enabled: user.enabled,
        editable: user.editable
    }
}